import { axiosInstance } from '../Api';
import axios from 'axios';
import { IResult } from '../../types/api';
export default class Metadata {
  private endPoint = 'Metadata';

  // get metadata like time definition of a given dataset
  async getMetadata(datasetId: string) {
    const r = await axiosInstance.get(
      `/${this.endPoint}/GetMetadata?datasetId=${encodeURIComponent(datasetId)}&key=&onCloud=true`
    );
    return { ...r?.data }; //{...r?.data, ItemsInfo: r?.data.ItemsInfo.map((item: IItemsInfo, index: number) =>  {return {...item, Index: index}})};
  }

  // get metadata like time definition of a given dataset
  async getMetadatas(datasetIds: string[]) {
    const requests = datasetIds.map((datasetId) =>
      axiosInstance
        .get(
          `/${this.endPoint}/GetMetadata?datasetId=${encodeURIComponent(datasetId)}&key=&onCloud=true`
        )
        .catch((_err) => null)
    );
    const responses = await axios.all(requests);
    return responses.map((response) => {
      return { ...response?.data };
    }); //, ItemsInfo: response?.data.ItemsInfo.map((item: IItemsInfo, index: number) =>  {return {...item, Index: index}})}});
  }


  // get metadata preview text
  async getMetadataPreviewText(datasetId: string) {
    const r = await axiosInstance.get<IResult<string>>(
      `/${this.endPoint}/GetMetaDataText?datasetId=${encodeURIComponent(datasetId)}`
    );
    return r?.data?.Result;
  }
}
